import styled from '@emotion/styled';

const Styled = styled.div`
  .card-dongle-logo {
    width: 175px;
  }
`;

export default Styled;
